import { LIST_WIDTH } from 'utils/constants/listview';

export const columns = [
  { headerName: 'Sender Name', field: 'senderName', width: LIST_WIDTH.md },
  { headerName: 'Title', field: 'title', width: LIST_WIDTH.md },
  { headerName: 'Message', field: 'body', width: LIST_WIDTH.lg },
  { headerName: 'Date Sent', field: 'dateSent', width: LIST_WIDTH.sm },
  {
    headerName: 'Recipient Name',
    field: 'recipientName',
    width: LIST_WIDTH.md,
  },
];
